import React from 'react';
import { Link } from 'react-scroll';

export const Terms = () => {
	return (
		<main role="main" className="block">
			<h1 className="sr-only visually-hidden">Assist@: Legal</h1>
			<div className="container-fluid container-hd legal-layout px-sm">
				<aside className="legal-aside">
					<h1 className="sr-only visually-hidden">Legal: Sidebar</h1>
					<ul className="list-unstyled mb-0 py-3 pt-md-1 sticky-top">
						<li className="mb-xs lh-copy">
							<Link className="text-uppercase font-weight-bold ls-n1 fs-3" activeClass="o-100 text-secondary" role="button" spy={true} hashSpy={true} smooth={true} offset={-100} duration={150} to="header">
								Conditions d'utilisation
							</Link>
						</li>
						<hr className="mt-0" />
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="OBJET">
								Objet
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="DEFINITIONS">
								Définitions
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="ABONNEMENT">
								Abonnement
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="DUREE">
								Durée
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="OBLIGATIONSASSIST">
								Obligations De Assist@
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="OBLIGATIONSClient">
								Obligations Du Client
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="DROITS">
								Droits D'utilisation
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="CONFIGURATION">
								Configuration Nécessaire
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PAIEMENT">
								Conditions De Paiement
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="GARANTIE">
								Garantie Et Maintenance
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PROPRIETE">
								Propriété Industrielle
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="ASSURANCES">
								Assurances
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="RESPONSABILITE">
								Responsabilité
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="RESILIATION">
								Résiliation Ou Suspension Du Contrat
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="FORCEMAJEURE">
								Force Majeure
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="CONFIDENTIALITE">
								Confidentialité
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PROTECTION">
								Protection Des Données A Caractère Personnel
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PARTAGE">
								Partage Des Données Collectées
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="COOKIES">
								Cookies
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="DISPOSITIONS">
								Dispositions Générales
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="LOI">
								Loi Applicable Et Juridique Compétente
							</Link>
						</li>
					</ul>
				</aside>
				<section className="legal-main pb-lg" id="detailLegal">
					<h1 className="sr-only visually-hidden">Legal: Main</h1>
					<header class="block" id="header">
						<div className="display-4 font-weight-bold ls-n1">Conditions d'utilisation</div>
						<p className="text-muted lh-copy mb-0">
							Version à jour au <span className="text-underline text-dark"> 01/08/2022 </span>
						</p>
						<hr class="mb-0" />
					</header>
					<article className="block pb-5" id="OBJET">
						<div className="block font-weight-demi text-uppercase text-center py-lg">
							<p className="mb-0">
								CONDITIONS GÉNÉRALES B to C
								<br />
								D'UTILISATION
								<br />
								DU LOGICIEL ASSIST@ (mode Saas)
								<br />
								ET DES PRESTATIONS DE SERVICES ASSOCIÉES
							</p>
						</div>
						<p className="font-weight-demi">Le Logiciel Assist@ est édité par :</p>
						<div className="block pb-5">
							<p className="mb-0">
								Assist@
								<br />
								Société au capital variable de 106 000 €
								<br />
								Immatriculée au RCS de CLERMONT-FERRAND sous le n° 888 659 455
								<br />
								Siège social : 10 allée Evariste Galois
								<br />
								63000 CLERMONT FERRAND
							</p>
						</div>
						<h2 className="text-uppercase font-weight-demi">OBJET</h2>
						<p>
							La société Assist@ a développé une plateforme logicielle en mode SaaS dénommée « Assist@ » (ci-après le « Logiciel »), destinée aux particuliers et qui permet d'accompagner les utilisateurs dans toutes les démarches administratives en cas d'événement de vie, via des services dénommés Anticipa, Facilita et
							Aidavie.
						</p>
						<p>Assist@ propose aux particuliers un service qui permet un gain de temps et qui s'adapte à chaque situation en personnalisant les démarches administratives de la gestion de documents, de l'archivage, en passant par l'impression jusqu'à l'envoi en fonction du service choisi.</p>
						<p>Assist@ travaille avec les moyens actuels de coffre-fort numérique pour l'archivage, la gestion, et la dématérialisation d'un maximum de services, notamment grâce à la digitalisation.</p>
						<p>Les présentes Conditions Générales d'Utilisation (ci-après dénommées « CGU ») ont pour objet de définir les conditions dans lesquelles Assist@ concède à ses Clients, les droits d'utilisation de son logiciel de gestion des démarches administratives « Assist@ », et en assure la maintenance.</p>
						<p>Les présentes Conditions Générales d'Utilisation, annulent et remplacent tous précédents documents commerciaux ou contrats passés entre le Client et Assist@.</p>
						<p>Préalablement à son inscription, le Client reconnaît avoir eu communication, de façon lisible et compréhensible, des CGU et des informations et renseignements prévus aux articles L111-1 à L111-7 du Code de la consommation.</p>
						<p className="mb-0">L'inscription sur le Site emporte adhésion et acceptation des CGU. Le Client ne pourra se prévaloir d'un document contradictoire.</p>
					</article>
					<article className="block pb-5" id="DEFINITIONS">
						<h2 className="text-uppercase font-weight-demi">DÉFINITIONS</h2>

						<p>Au titre des présentes conditions, les mots ci-après auront la signification suivante :</p>
						<ul class="pl-sm">
							<li>
								<strong>Anticipa</strong> désigne l'abonnement et le service permettant de lister et centraliser l'intégralité de sa vie administrative, avec un accompagnement administratif personnalisé en cas d'événement de vie et la transmission du dossier à un proche désigné en cas de décès.
							</li>
							<li>
								<strong>Facilita</strong> désigne l'abonnement et le service qui permet un accompagnement dans les démarches administratives liées au décès.
							</li>
							<li>
								<strong>Aidavie</strong> désigne le service qui permet d'obtenir un bilan complet personnalisé des démarches à faire en fonction de l'événement de vie sélectionné (déménagement, mariage, naissance, divorce, passage à la retraite et décès).
							</li>
							<li>
								<strong>Client</strong> : désignent les particuliers Client du Logiciel et bénéficiaires des prestations et en raison de la nature particulière des contrats, les ayant droits désignés dans le contrat en cas de décès.
							</li>
							<li>
								<strong>Contrat</strong> : désigne les présentes CGU ainsi que le Tarif publié, la commande et toute autre documentation juridique et commerciale échangée entre les Parties.
							</li>
							<li>
								<strong>Logiciel</strong> : désigne le logiciel Assist@, logiciel de suivi des démarches administratives pré et post décès, mis à disposition par la société Assist@ via une licence et servant de base à la prestation rendue.
							</li>
							<li>
								<strong>Parties</strong> : désignent le Client et la société Assist@.
							</li>
							<li>
								<strong>Services</strong> : désignent les prestations incluses dans le Tarif publié et proposé au Client.
							</li>
							<li>
								<strong>Tarifs</strong> : désignent les tarifs forfaitaires et hors forfait en vigueur à la date de signature du contrat et publiés sur le site Assist@.
							</li>
						</ul>
					</article>
					<article className="block pb-5" id="ABONNEMENT">
						<h2 className="text-uppercase font-weight-demi">ABONNEMENT</h2>

						<p>L'inscription au Site est ouverte à toutes les personnes morales ou physiques majeures et jouissant de leurs pleines personnalités et capacités juridiques.</p>

						<p>L'utilisation des Services proposés sur le Site est conditionnée à l'inscription du Client sur le Site.</p>

						<p>Un Client peut s'inscrire directement via le site internet mais également en passant par un prestataire partenaire. Dans les deux cas, le Client est tenu aux informations indiquées sur ces CGU.</p>

						<p>Pour procéder à l'inscription, le Client doit remplir tous les champs obligatoires, sans lesquels le service ne peut être délivré. A défaut, l'inscription ne pourra être complétée.</p>

						<p>
							Pour le service pré décès "Anticipa", pour effectuer une inscription, le Client doit créer un compte via le lien partenaire qu'il aura reçu, personnaliser son profil, indiquer sa situation de vie, choisir un ou des référents qui seront les personnes de confiance qui valideront l'ouverture du dossier
							administratif et l'envoi des courriers le moment venu.
						</p>

						<p>De plus, il devra compléter les organismes de bases et les organismes complémentaires, puis valider.</p>

						<p>
							Pour le service post décès "Facilita", pour effectuer une inscription, le Client doit créer un compte via le lien partenaire qu'il aura reçu lui permettant de se connecter à la plateforme. Elle devra créer un compte, informer d'autres personnes de la famille si elle le souhaite, compléter le dossier et
							valider le service Facilita.
						</p>

						<p>
							Pour le service "Aidavie", le Client suivra directement le lien sur le site du Partenaire et pourra créer son compte en toute autonomie, sélectionner l'événement de vie correspondant à sa situation, indiquer sa situation de vie, sélectionner les organismes avec lesquels il est en lien avant d'accéder à
							des fiches pratiques et un bilan personnalisé des démarches à effectuer.
						</p>

						<p>
							L'enregistrement d'une Commande sur le Site est réalisé lorsque le Client accepte les CGU en cliquant sur « Passer à l’étape suivante » et valide son inscription. Cette validation constitue une preuve du contrat de vente. La finalisation de la Commande implique l'acceptation des prix et des modalités de
							réalisation des prestations telles qu'indiquées sur le Site.
						</p>

						<p>Une fois son inscription passée, le Client en recevra confirmation par courrier électronique. Cette confirmation fera le récapitulatif de l’Inscription et des informations relatives à la réalisation de la ou des prestations.</p>

						<p>
							En cas de défaut de paiement, d'adresse erronée du Client ou autre problème sur le compte du Client, Assist@ se réserve le droit de bloquer l'Inscription du Client jusqu'à ce que le problème soit résolu. En cas d'impossibilité de réaliser la prestation, le Client en sera informé par courrier électronique
							à l'adresse qu'il aura fournie à Assist@.
						</p>

						<p>L'annulation de l'Inscription de cette prestation et son remboursement seront dans ce cas effectués.</p>

						<p>
							Le Client garantit et déclare sur l'honneur que toutes les informations communiquées sur le Site, notamment lors de leur inscription, sont exactes et conformes à la réalité. Il s'engage à mettre à jour leurs informations personnelles à partir de la page dédiée à ces dernières et disponible dans leur
							compte.
						</p>

						<p>
							Tout Client enregistré dispose d'un identifiant et d'un mot de passe. Ces derniers sont strictement personnels et confidentiels et ne devront en aucun cas faire l'objet d'une communication à des tiers sous peine de suppression du compte du Client enregistré contrevenant. Chaque Client inscrit est
							personnellement responsable du maintien de la confidentialité de son identifiant et de son mot de passe. La Société ne sera en aucun cas tenue pour responsable de l'usurpation d'identité d'un Client. Si un Client suspecte une fraude à n'importe quel moment, il devra contacter Assist@ dans les plus brefs
							délais afin que cette dernière puisse prendre les mesures nécessaires et régulariser la situation.
						</p>

						<p>Chaque Client, qu'il soit une personne morale ou physique, ne peut être titulaire que d'un compte sur le Site.</p>

						<p>En cas de non-respect des CGU, notamment la création de plusieurs comptes pour une seule personne ou encore la fourniture de fausses informations, Assist@ se réserve le droit de procéder à la suppression temporaire ou définitive de tous les comptes créés par le Client enregistré contrevenant.</p>

						<p>La suppression du compte entraîne la perte définitive de tous les avantages et services acquis sur le Site. Cependant, toute Commande réalisée et facturée par le Site avant la suppression du compte sera exécutée dans les conditions normales.</p>

						<p>
							En cas de suppression d'un compte par Assist@ pour manquement aux devoirs et obligations énoncées dans les CGU, il est formellement interdit au Client contrevenant de se réinscrire sur le Site directement, par le biais d'une autre adresse électronique ou par personne interposée sans l'autorisation
							expresse de Assist@.
						</p>
					</article>
					<article className="block pb-5" id="DUREE">
						<h2 className="text-uppercase font-weight-demi">DURÉE</h2>

						<p>Le Contrat Anticipa est conclu pour une durée d'un (1) an à compter de la date de facture adressée au Client. Il est par la suite renouvelé tacitement pour une nouvelle période de un an.</p>

						<p>Conformément à la loi Chatel (Article L 136-1 du code de la consommation), Assist@ informera le Client de la date de l'échéance dans un délai compris au plus tard 1 mois avant la date de renouvellement du contrat d'abonnement, et de la possibilité pour l'abonné de ne pas reconduire son contrat.</p>

						<p>En raison de nature, le contrat Facilita constitue une prestation unique dans le cadre d'un abonnement de un an et qui expire une fois les travaux réalisés.</p>

						<p>Le Contrat Aidavie est conclu pour une durée d'un (1) an à compter de la date de facture adressée au Client. Il est par la suite renouvelé tacitement pour une nouvelle période de un an.</p>

						<p>Conformément à la loi Chatel (Article L 136-1 du code de la consommation), Assist@ informera le Client de la date de l'échéance dans un délai compris au plus tard 1 mois avant la date de renouvellement du contrat d'abonnement, et de la possibilité pour l'abonné de ne pas reconduire son contrat.</p>

						<p>Le Contrat est reconduit tacitement par périodes successives de douze (12) mois à chaque date d'anniversaire, sauf dénonciation par l'une des Parties par lettre recommandée avec avis de réception au moins trois (3) mois avant l'expiration de la période en cours.</p>

						<p>Le Client accède au service en ligne par Internet, par le biais du Site, à l'aide d'un identifiant et d'un mot de passe qui lui sont communiqués dès la création de son compte.</p>

						<p>Le Client aura ainsi accès au service en mode SaaS 24h/24 et 7j/7 sauf en cas d'opérations de maintenance, pannes éventuelles ou force majeure affectant Assist@.</p>

						<p>Le Client fait son affaire de souscrire, auprès d'un fournisseur d'accès à Internet, un abonnement lui permettant d'accéder au Site et au service. Le Client s'assure de la compatibilité de son environnement technique requise pour l'accès et/ou l'utilisation du service.</p>
					</article>
					<article className="block pb-5" id="OBLIGATIONSASSIST">
						<h2 className="text-uppercase font-weight-demi">OBLIGATIONS DE ASSIST@</h2>

						<ol class="pl-sm">
							<li>
								<p>
									Assist@ s'engage à mettre à disposition du Client le Logiciel via Internet et s'engage à ce titre à fournir au Client un code d'accès personnel durant la durée de mise à disposition des droits d'utilisation du Logiciel. La remise de l'accès et l'installation du Logiciel sera réputée réalisée dès la
									transmission du code d'accès au Client.
								</p>
							</li>
							<li>
								<p>Assist@ a un rôle de conseil et d'assistance à l'égard du Client dans la limite de ses obligations de moyens telles que précisées aux présentes CGU.</p>

								<ul class="pl-sm">
									<li>
										<p>A ce titre, Assist@ s'engage à lui apporter toutes informations utiles et tous conseils pour lui permettre de mener à bien ses objectifs.</p>
									</li>
									<li>
										<p>Assist@ s'engage à apporter une assistance technique par la case « Besoin d'aide ? FAQ » incluse dans la tarification dans les conditions décrites sur le site Internet.</p>
									</li>
									<li>
										<p>La responsabilité de Assist@ est strictement limitée à cet égard aux fonctionnalités du logiciel telles que décrites dans la proposition technique publiée sur son site internet.</p>
									</li>
									<li>
										<p>Sa responsabilité ne pourra en aucun cas être engagée au-delà d'une année d'abonnement perçu dans l'année civile précédant le dommage et sous réserve de confirmation de la responsabilité de Assist@.</p>
									</li>
									<li>
										<p>Assist@ informera le Client des difficultés rencontrées dès qu'elle en aura connaissance et s'engage à transmettre au Client ses demandes de renseignement et ses éléments de solution.</p>
									</li>
								</ul>
							</li>
							<li>
								<p>Assist@ s'oblige à employer un personnel compétent lié par des clauses de confidentialité et s'engage à faire respecter par son personnel les obligations de confidentialité vis-à-vis du Client.</p>
							</li>
							<li>
								<p>Pendant la durée du Contrat, le Client bénéficie de la fourniture et l'installation des mises à jour correctives et technologiques de la Plateforme d'Exploitation.</p>
							</li>
							<li>
								<p>Par ailleurs, Assist@ fournira au Client une assistance téléphonique et des services de maintenance (ci-après « les Prestations ») relatifs au Logiciel.</p>
							</li>
						</ol>
						<div className="pl-sm">
							<p>Exception faite des jours fériés et des jours exceptionnels de fermeture d'Assist@, et sauf cas de force majeure tels que définis aux présentes, les heures d'intervention de cette équipe d'assistance sont de 9h00 à 18h00 (heure métropolitaine) du lundi au vendredi.</p>
							<p>Assist@ se réserve le droit de modifier ces horaires et préviendra par tout moyen à sa convenance le Client des nouvelles plages horaires.</p>

							<p className="mt-gutter">Sont exclues des prestations réalisées par Assist@ au titre du présent Contrat :</p>
							<ul class="pl-sm">
								<li>
									<p>une utilisation anormale du logiciel quelle qu'en soit la raison (notamment en cas de négligence, erreur de manipulation, accident…) ;</p>
								</li>
								<li>
									<p>un problème de compatibilité entre le Logiciel et tout autre matériel du Client ou une défaillance de ce matériel ;</p>
								</li>
								<li>
									<p>un problème de compatibilité entre les réseaux de télécommunications et le Logiciel;</p>
								</li>
							</ul>
						</div>
					</article>
					<article className="block pb-5" id="OBLIGATIONSClient">
						<h2 className="text-uppercase font-weight-demi">OBLIGATIONS DU CLIENT</h2>
						<ol class="pl-sm">
							<li>
								<p>
									Le Client s'engage à fournir dans les délais requis les documents nécessaires, et notamment l'acte de décès ou nous permettre de l'obtenir directement l'ensemble des informations et documents nécessaires à Assist@ pour la réalisation des prestations convenues, telles que définies et validées en commun
									dans le Tarif publié.
								</p>
							</li>
							<li>
								<p>Le Client s'engage à disposer d'une configuration matérielle, logicielle et réseau appropriée, conformément aux recommandations fournies par Assist@.</p>
							</li>
							<li>
								<p>Le Client s'engage à respecter les conditions financières qui lui incombent.</p>
							</li>
						</ol>
					</article>
					<article className="block pb-5" id="DROITS">
						<h2 className="text-uppercase font-weight-demi">DROITS D'UTILISATION</h2>

						<p>Assist@ concède au Client, qui accepte, un droit d'utilisation non transférable et non exclusif du Logiciel pour toute la durée de la licence consentie.</p>

						<p>Les droits d'utilisation du Logiciel concédés par Assist@ au Client sont personnels et ne sont pas cessibles ou transférables.</p>

						<p>Toute évolution des logiciels et des services associés donnera lieu à la publication de nouveaux tarifs avec la possibilité de conclure de nouveaux contrats.</p>

						<p>Le Client s'interdit tout type d'exploitation non explicitement autorisée par les présentes et par le Tarif publié.</p>
					</article>
					<article className="block pb-5" id="CONFIGURATION">
						<h2 className="text-uppercase font-weight-demi">CONFIGURATION NÉCESSAIRE</h2>

						<p>Le Logiciel est optimisé pour fonctionner à partir d'un ordinateur disposant d'une connexion Internet avec un débit suffisant et à partir de l'un des navigateurs compatibles suivants : versions plus récentes de Google Chrome, Microsoft Edge, Safari et Mozilla Firefox.</p>

						<p>Assist@ recommande l'usage de ce navigateur et ne pourrait en aucun cas être tenue responsable des dysfonctionnements observés chez le Client, liés à l'usage d'un autre navigateur web.</p>
					</article>
					<article className="block pb-5" id="PAIEMENT">
						<h2 className="text-uppercase font-weight-demi">CONDITIONS DE PAIEMENT</h2>

						<p>L'exécution du Contrat donnera lieu de la part de Assist@, à la facturation d'un abonnement dont les modalités et l'échéancier sont précisés dans le Tarif publié remis au Client et sur la base des tarifications publiées par Assist@ sur son site Internet.</p>

						<p>Le paiement de l'ouverture du compte d'accès au Logiciel se fera par virement à la signature lors de la commande.</p>

						<p>Le paiement peut être réalisé par Carte bancaire</p>
						<p>En cas de non-respect des conditions de paiement décrites ci-dessus, Assist@ se réserve la possibilité d'annuler ou de suspendre la vente.</p>
						<p>
							S'agissant d'une commande de prestations immatérielle numérique instantanée, et conformément à l'article{" "}
							<a className="text-info btn-link font-weight-bold" target="blank" href="https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000032226820/2016-07-01">
								Article L221-28
							</a>{" "}
							du code de la consommation, le Client ne bénéficie pas d'un droit de rétractation.
						</p>

						<p>Les mensualités postérieures dues au titre de la licence conférée au Client et/ou des prestations réalisées, auront lieu directement par prélèvement bancaire tous le 5 de chaque et en fonction du type de tarification souscrite.</p>

						<p>Lors de la signature électronique du Contrat, le Client communiquera à Assist@ l'ensemble de ses coordonnées bancaires nécessaires à la mise en œuvre du prélèvement.</p>

						<p>Un contrat de maintenance corrective est intégré dans la tarification.</p>

						<p>
							Assist@ se réserve la possibilité de réviser ses tarifs annuellement sous réserve d'en informer le Client dans des délais compatibles avec la notification de renouvellement visée à l'article 3, en appliquant la variation de l'indice SYNTEC (Chambres syndicale des SSII et éditeurs de logiciels publié
							notamment sur le site{" "}
							<a className="text-info btn-link font-weight-bold" target="blank" href="https://syntec-numerique.fr/indice-syntec">
								https://syntec-numerique.fr/indice-syntec
							</a>
							) majorée de 3 points de pourcentage, étant entendu que la variation de l'indice SYNTEC retenue sera celle observée sur l'ensemble de la période courant depuis la dernière révision de prix appliquée par Assist@.
						</p>

						<p>
							Conformément à l'article L 441-10 du Code de commerce, toute facture non payée à son échéance entraînera la facturation d'intérêts de retard fixés à trois fois le taux d'intérêt légal, ce taux est égal au taux d'intérêt appliqué par la Banque centrale européenne à son opération de refinancement la plus
							récente majoré de 10 points de pourcentage et d'une indemnité forfaitaire de quarante (40) euros.
						</p>

						<p>En outre, en cas de défaut des démarches administratives ou de rejet de prélèvement, Assist@ se réserve également le droit de suspendre l'abonnement au Logiciel jusqu'à son règlement complet.</p>
					</article>
					<article className="block pb-5" id="GARANTIE">
						<h2 className="text-uppercase font-weight-demi">GARANTIE ET MAINTENANCE</h2>

						<p>Assist@ garantit que le Logiciel fonctionnera conformément à sa description dans le Tarif publié.</p>

						<p>Assist@ s'engage à assurer gratuitement pendant la période contractuelle, la correction des éventuels bugs, des anomalies, des dysfonctionnements, incidents, erreurs ou défauts de fonctionnement du Logiciel.</p>

						<p>Dans le cas où le Client viendrait à constater des bugs ou tout autre dysfonctionnement du Logiciel, ce dernier les notifiera à Assist@ qui les corrigera dans le cadre de la garantie offerte par Assist@ au Client.</p>

						<p>Ne sont pas inclus dans les Services fournis au titre du Contrat les prestations suivantes :</p>
						<ul class="pl-sm">
							<li>La rectification de données perdues ou corrompues du fait de Assist@.</li>
							<li>Le diagnostic et/ou rectification de problèmes non relatifs au Logiciel.</li>
							<li>La perte ou dommages causés directement ou indirectement par une erreur ou une omission de l'opérateur.</li>
						</ul>
					</article>
					<article className="block pb-5" id="PROPRIETE">
						<h2 className="text-uppercase font-weight-demi">PROPRIÉTÉ INDUSTRIELLE</h2>

						<p>Assist@ garantit qu'elle est titulaire de tous les droits de propriété intellectuelle et titres de propriété industrielle sur le Logiciel et sa documentation associée, nécessaires à l'exécution du Contrat.</p>

						<p>Le Contrat n'entraîne aucun transfert de propriété sur les logiciels, méthodes, outils de développement, savoir-faire, documents, fichiers propriété de Assist@ ou sur lesquels Assist@ a obtenu une licence.</p>
					</article>
					<article className="block pb-5" id="ASSURANCES">
						<h2 className="text-uppercase font-weight-demi">ASSURANCES</h2>

						<p>Assist@ déclare être assurée en responsabilité civile pour les éventuels dommages qui pourraient être consécutifs à l'exécution du présent Contrat.</p>
					</article>
					<article className="block pb-5" id="RESPONSABILITE">
						<h2 className="text-uppercase font-weight-demi">RESPONSABILITÉ</h2>

						<p>Assist@ est responsable dans les conditions de droit commun uniquement des dommages directs survenus au Client à l'occasion de l'exécution du présent Contrat.</p>

						<p>La responsabilité de Assist@ ne peut être recherchée pour un dommage, quel qu'il soit, relevant d'un usage anormal du Logiciel par le Client.</p>

						<p>
							En aucun cas Assist@ ne peut être tenue responsable, au titre d'une action en responsabilité contractuelle ou extracontractuelle, ou de toute autre action, de tout dommage direct ou indirect, incident ou accessoire, de quelque nature qu'il soit résultant de l'utilisation du Logiciel ou d'une quelconque
							information obtenue par l'intermédiaire de ce dernier.
						</p>

						<p>
							En cas de préjudice indemnisable subi par le Client au titre du présent Contrat, le montant total cumulé des dommages et intérêts auquel pourrait être tenu Assist@ ne pourra, en tout état de cause, excéder le montant annuel facturé hors taxes et payé par le Client au titre du présent Contrat sur l'année
							civile en cours au jour du dommage.
						</p>

						<p>En aucun cas, la responsabilité de Assist@ ne saurait être recherchée en cas de dommage résultant exclusivement de force majeure, faute, négligence, omission ou défaillance du Client.</p>
					</article>
					<article className="block pb-5" id="RESILIATION">
						<h2 className="text-uppercase font-weight-demi">RÉSILIATION OU SUSPENSION DU CONTRAT</h2>

						<p>
							En cas de manquement par l'une des Parties aux obligations des présentes, non réparé dans un délai de trente (30) jours à compter de la réception de la lettre recommandée avec avis de réception notifiant les manquements en cause, l'autre Partie pourra faire valoir la résiliation de plein droit du Contrat,
							sous réserve de tous dommages et intérêts auxquels elle pourrait prétendre du fait desdits manquements.
						</p>

						<p>
							En cas de non-paiement ou de rejet du prélèvement automatique, Assist@ se réserve le droit, après mise en demeure restée infructueuse dans un délai de huit (8) jours à compter de sa réception, de suspendre l'exécution du contrat et l'accès au Logiciel. A défaut de régularisation de la situation dans un
							délai raisonnable, Assist@ pourra ensuite résilier le Contrat dans les conditions décrites ci-dessus.
						</p>

						<p>En cas de résiliation, Assist@ s'engage à effacer et supprimer de son système les données appartenant au Client. Cette suppression aura lieu dans les 10 jours suivant la demande du Client.</p>

						<p>En cas de résiliation du contrat ou de disparition de la société Assist@, le Client bénéficie d'une garantie de récupération de son dossier qui sera conservé chez un hébergeur mandaté par Assist@ pour lui restituer son dossier.</p>
					</article>
					<article className="block pb-5" id="FORCEMAJEURE">
						<h2 className="text-uppercase font-weight-demi">FORCE MAJEURE</h2>

						<p>Assist@ ne peut être tenue pour responsable de l'inexécution de ses obligations prévues à ce Contrat, si cette inexécution est due à un cas de force majeure.</p>

						<p>
							A ce titre, au sens de l'article 1218 du Code civil : « il y a force majeure en matière contractuelle lorsqu'un événement échappant au contrôle du débiteur, qui ne pouvait être raisonnablement prévu lors de la conclusion du contrat et dont les effets ne peuvent être évités par des mesures appropriées,
							empêche l'exécution de son obligation par le débiteur. Si l'empêchement est temporaire, l'exécution de l'obligation est suspendue à moins que le retard qui en résulterait ne justifie la résolution du contrat. Si l'empêchement est définitif, le contrat est résolu de plein droit et les parties sont libérées
							de leurs obligations dans les conditions prévues aux articles 1351 et 1351-1. »
						</p>

						<p>Les obligations ainsi suspendues seront exécutées à nouveau dès que les effets de la ou des causes de non-exécution auront pris fin, dans les meilleurs délais.</p>

						<p>
							Dans l'éventualité où un événement de force majeure venait à différer l'exécution des obligations prévues au Contrat pendant une période supérieure à six (6) mois, chacune des Parties pourra résilier le Contrat par lettre recommandée avec accusé de réception, sans pouvoir exiger de l'autre Partie aucune
							indemnité.
						</p>
					</article>
					<article className="block pb-5" id="CONFIDENTIALITE">
						<h2 className="text-uppercase font-weight-demi">CONFIDENTIALITÉ</h2>

						<p>
							Chacune des Parties s'engage à respecter la confidentialité de l'ensemble des informations et documents techniques ou commerciaux provenant de l'autre Partie et relatifs à l'exécution du Contrat (ci-après dénommées les « Informations Confidentielles »), qui lui ont été révélés ou auxquels elle aurait eu
							accès à l'occasion de l'exécution des Services.
						</p>

						<p>Il est expressément convenu entre les Parties que toutes les données et informations que le Client intégrera au Logiciel sont considérées comme des Informations Confidentielles au titre du présent article.</p>

						<p>En particulier, chaque Partie :</p>
						<ul class="pl-sm">
							<li>n'utilisera ces Informations Confidentielles que pour la réalisation des Services auxquelles elles se rattachent,</li>
							<li>ne les communiquera qu'à ceux de ses employés à qui ces informations et documents seront indispensables pour l'exécution des Services ou à des tiers qu'après accord préalable écrit de l'autre Partie,</li>
							<li>prendra à l'égard de son personnel et des tiers autorisés, toutes les mesures nécessaires pour assurer cette confidentialité,</li>
							<li>restituera ou détruira tout document contenant ces Informations Confidentielles dès que celles-ci ne lui seront plus nécessaires et au plus tard à la fin du Contrat.</li>
						</ul>
						<p>La présente obligation de confidentialité ne s'applique pas à la partie des informations :</p>
						<ul class="pl-sm">
							<li>tombée dans le domaine public à la date de sa communication par la Partie émettrice ou qui tomberait dans le domaine public postérieurement à cette date et sans faute de la Partie réceptrice,</li>
							<li>déjà connue de la Partie réceptrice au moment de sa communication,</li>
							<li>transmise à la Partie réceptrice avec dispense écrite de confidentialité de la Partie émettrice.</li>
						</ul>
						<p>La présente obligation de confidentialité restera en vigueur postérieurement à la résiliation du contrat.</p>
					</article>
					<article className="block pb-5" id="PROTECTION">
						<h2 className="text-uppercase font-weight-demi">PROTECTION DES DONNÉES À CARACTÈRE PERSONNEL</h2>

						<p>Le Client est informé que, dans le cadre de la gestion des opérations relatives à la relation contractuelle avec ses Clients, des données à caractère personnel sont traitées par Assist@ en tant que responsable de traitement.</p>

						<p>
							En conformité avec la Loi française Informatique et Liberté ainsi qu'avec les règles applicables depuis le 25 mai 2018 en application du Règlement Général européen sur la Protection des Données, les données concernées sont conservées par Assist@ pendant toute la durée de la relation contractuelle
							augmentée des durées légales de prescription.
						</p>

						<p>
							Le Client bénéficie, dans les conditions prévues par la loi, d'un droit d'interrogation, d'accès, de rectification, d'un droit à la portabilité, à la limitation du traitement et d'opposition pour raisons légitimes, ainsi que du droit de définir des directives relatives au sort de ses données après sa
							mort.
						</p>

						<p>
							Il peut exercer ces droits en s'adressant à la société Assist@ à l'adresse mail suivante :{" "}
							<a className="text-info btn-link font-weight-bold" target="blank" href="mailto:rectificationdemesdonnees@assistarobase.fr">
								rectificationdemesdonnees@assistarobase.fr
							</a>{" "}
							(DPO Externe).
						</p>

						<p>
							En cas de contestation, il peut former une réclamation auprès de la CNIL dont les coordonnées figurent à l'adresse suivante :{" "}
							<a className="text-info btn-link font-weight-bold" target="blank" href="https://www.cnil.fr">
								https://www.cnil.fr
							</a>
							.
						</p>
					</article>
					<article className="block pb-5" id="PARTAGE">
						<h2 className="text-uppercase font-weight-demi">PARTAGE DES DONNÉES COLLECTÉES</h2>

						<p>Le Site peut avoir recours à des sociétés tierces pour effectuer certaines opérations.</p>
						<p>En naviguant sur le Site, le Client accepte que des sociétés tierces puissent avoir accès à ses données pour permettre le bon fonctionnement du Site.</p>
						<p>Ces sociétés tierces n'ont accès aux données collectées que dans la cadre de la réalisation d'une tâche précise et dans le cadre du respect du RGPD.</p>
						<p>Par ailleurs, le Client peut donc être amené à recevoir des informations ou des offres commerciales de la part de Assist@ ou de ses partenaires, sous réserve de son acceptation préalable.</p>
						<p>Le Client peut à tout moment s'opposer à la réception de ces offres commerciales, en écrivant à l'adresse de Assist@ indiquée ci-dessus, ou en cliquant sur le lien prévu à cet effet au sein des courriers électroniques reçus.</p>
						<p>Par ailleurs, les informations des Clients pourront être transmises à des tiers sans leur accord express préalable dans les cas prévus par la loi.</p>
					</article>
					<article className="block pb-5" id="COOKIES">
						<h2 className="text-uppercase font-weight-demi">COOKIES</h2>

						<p>
							Pour permettre à ses Clients de bénéficier d'une navigation optimale sur le Site et d'un meilleur fonctionnement des différentes interfaces et applications, Assist@ est susceptible d'implanter un cookie sur l'ordinateur du Client. Ce cookie permet de stocker des informations relatives à la navigation sur
							le Site, ainsi qu'aux éventuelles données saisies par les Client (notamment recherches, login, email, mot de passe).
						</p>
						<p>Le Client autorise expressément Assist@ à déposer sur le disque dur du Client un fichier dit « cookie ».</p>
						<p>
							Le Client dispose de la possibilité de bloquer, modifier la durée de conservation, ou supprimer ce cookie via l'interface de son navigateur. Si la désactivation systématique des cookies sur le navigateur du Client l'empêche d'utiliser certains services ou fonctionnalités du Site, ce dysfonctionnement ne
							saurait en aucun cas constituer un dommage pour le membre qui ne pourra prétendre à aucune indemnité de ce fait.
						</p>
					</article>
					<article className="block pb-5" id="DISPOSITIONS">
						<h2 className="text-uppercase font-weight-demi">DISPOSITIONS GÉNÉRALES</h2>

						<p>Dans le cas où une des clauses du Contrat serait déclarée nulle ou sans objet, cette clause est réputée non-écrite et ne saurait entraîner la nullité du Contrat dans son ensemble, sauf si ladite clause constitue une condition substantielle de l'engagement de l'une ou l'autre des parties.</p>

						<p>Aucune renonciation de l’une ou l’autre des Parties à se prévaloir de l’un quelconque de ses droits conformément aux termes du Contrat, ne saurait constituer une renonciation pour l’avenir auxdits droits.</p>
					</article>
					<article className="block pb-lg" id="LOI">
						<h2 className="text-uppercase font-weight-demi">LOI APPLICABLE ET JURIDIQUE COMPÉTENTE</h2>

						<p>Le présent Contrat est régi par la loi française.</p>

						<p>En cas de litige, les deux Parties feront tous leurs efforts pour trouver une solution amiable.</p>
						<p>A défaut de solution amiable, tout litige relatif à l'application, l'exécution ou l'interprétation du Contrat sera, de convention expresse, porté devant les tribunaux compétents de Clermont-Ferrand.</p>

						<p>Le Client est informé qu'il peut recourir à une médiation prévue à l'article L612-1 du Code de la consommation via la commission paritaire de la vente directe http://mediation-vente-directe.fr/. Il peut également recourir à tout mode alternatif de règlement des différends en cas de litige.</p>
					</article>
				</section>
			</div>
		</main>
	);
}